import { Heading } from "@/components/ui/heading";
import { RegularPageLayout } from "@/components/layout/PageLayouts";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth-context";
import ApiKeyPricingCard from "@/components/pricing/ApiKeyPricingCard";
import { WORDS_MIN } from "@textformatter/shared";
export default function PricingPage() {
	const navigate = useNavigate();
	const { user } = useAuth();

	return (
		<RegularPageLayout width="6xl" paddingY="8">
			<section className="rounded-2xl border border-slate-200 bg-white p-6 sm:p-8">
				<Heading>Pricing</Heading>
				<div className="mt-6 space-y-4 text-sm leading-7 text-slate-700 sm:text-base">
					<p>
						Use <b>Text Formatter</b> in your browser <b>for free</b>. For API usage, choose how
						many words you want to process and pay based on volume.
					</p>
					<p>
						Pricing uses gradual volume discounts and updates continuously with your selected word
						amount.
					</p>
				</div>
			</section>
			<ApiKeyPricingCard
				title="Estimate API Key Pricing"
				initialWords={WORDS_MIN}
				labelPlaceholder="Key 1"
				showLabelInput={Boolean(user)}
				buttonText="Create key"
				onCreate={({ words, label }) => {
					if (!user) {
						navigate("/login");
						return;
					}
					const params = new URLSearchParams({
						words: String(words),
						label,
					});
					navigate(`/dashboard/payment?${params.toString()}`);
				}}
			/>
		</RegularPageLayout>
	);
}
